import { z } from 'zod';

import { defineCommand } from '@nesso/common-contracts/define';
import { practiceIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import {
    FEES_SETTINGS_TYPE,
    feesSettingsPatchSchema,
    SUPERBILL_SETTINGS_TYPE,
    superbillSettingsPatchSchema,
} from './client-billing-settings.models';

export const CLIENT_BILLING_SETTINGS_UPDATE_TYPE = 'client-billing-settings/update';

export const clientBillingSettingsUpdate = defineCommand(
    CLIENT_BILLING_SETTINGS_UPDATE_TYPE,
    z.discriminatedUnion('type', [
        z.object({
            practiceId: practiceIdSchema.meta(metadata.recordId),
            type: z.literal(SUPERBILL_SETTINGS_TYPE),
            value: superbillSettingsPatchSchema,
        }),
        z.object({
            practiceId: practiceIdSchema.meta(metadata.recordId),
            type: z.literal(FEES_SETTINGS_TYPE),
            value: feesSettingsPatchSchema,
        }),
    ]),
);
